import { authService } from "./authServices";

export const userService = authService.injectEndpoints({
    reducerPath: 'userService',
    endpoints: (builder) => {
        return {
            getUser: builder.query({
                query: () => {
                    return {
                        url: '/user/get-user',
                    };
                },
                providesTags: ['USER']
            }),
            updateUser: builder.mutation({
                query: (data) => {
                    return {
                        url: '/user/update-user',
                        method: 'PUT',
                        body: data,
                    };
                },
                invalidatesTags: ['USER']
            }),
            contactUser: builder.mutation({
                query: (data) => {
                    return {
                        url: '/user/contact',
                        method: 'POST',
                        body: data,
                    };
                },
            }),
            refreshNoti: builder.mutation({
                queryFn: () => ({ data: null }),
                invalidatesTags: ['USER']
            })
        };
    }
});

export const { useUpdateUserMutation, useGetUserQuery, useContactUserMutation, useRefreshNotiMutation } = userService;